module.exports = __webpack_public_path__ + "img/vip-coin-stack.cfd357b3.png";